<template lang="pug">
#gestao-contratos-originacao
    BaseHeader#novo-contrato-originacao(
        :titulo='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.titulo")',
        icon='mdi mdi-file-plus',
        :btnTexto='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.botaoNovoContrato")',
        :exibeBotao='true',
        :botoesSecundarios='this.usuarioLogado.ambienteLogado === "AR" ? botoesSecundarios : []',
        @btnHeaderClicado='novoContrato',
        @botaoSecundarioHeaderClicado='uploadPlanilha'
    )

    .view-container.margen-bottom-pages
        BlocoInformacaoBR(
            v-if='this.usuarioLogado.ambienteLogado === "BR"',
            :totalContratosOriginacao='totalContratosOriginacao',
            :totalizador='totalizador',
            :skeletonBlocoInforDados='skeletonBlocoInforDados',
            :codigosStatusAtivo='codigosStatusAtivo',
            :filtroTotalizadorEudr='filtroTotalizadorEudr',
            :statusEmitidos='statusEmitidos',
            @handlerEudrFilter='handlerEudrFilter',
            @aplicarFiltroStatus='aplicarFiltroStatus'
        )

        BlocoInformacaoPaises(
            v-else,
            :totalContratosOriginacao='totalContratosOriginacao',
            :totalizador='totalizador',
            :skeletonBlocoInforDados='skeletonBlocoInforDados',
            :isBunge='isBunge',
            :codigosStatusAtivo='codigosStatusAtivo',
            :status='statusContrato',
            @emitStatus='statusEmpresa',
            @emitFiltroStatus='aplicarFiltroStatus'
        )
            BlocoInformacaoSkeleton(
                v-if='usuarioLogado.ambienteLogado === ambientes.BRASIL',
                :carregando='skeletonBlocoInforDados'
            )
                BlocoInformacao.text-with(
                    :titulo='$t("mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.totalizadorEudr")',
                    :numero='totalContratosOriginacao?.totalEudr',
                    :class='{ "bloco-infor-dados-ativo": filtroTotalizadorEudr }',
                    @click.native='handlerEudrFilter()'
                )
                    template(slot='icone')
                        i.mdi.mdi-dots-circle

        .bloco-pesquisa-filtros
            BlocoPesquisaFiltros(
                :carregandoStatusEmpresa='carregandoStatusEmpresa',
                :statusEmpresa='statusContrato',
                @emitFiltros='adicionarFiltros',
                @emitStatus='statusEmpresa',
                ref='aplicarFiltroStatus'
            )

        .secao-listagem-filtro
            .titulo-listagem
                h3 {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.subTituloListagemContratos') }}

            .base-button-exportar-relatorio
                el-button.base-button-container__btn(
                    v-if='this.usuarioLogado.ambienteLogado !== "PY"',
                    type='primary',
                    :icon='"el-icon-download"',
                    @click='exportarRelatorioXlsx()'
                )
                    | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.subTituloExportarRelatorio') }}

                el-button.base-button-container__btn(
                    v-else,
                    type='primary',
                    :icon='"el-icon-download"',
                    @click='exportarInformesPY()'
                )
                    | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.subTituloExportarRelatorio') }}

            .check-campos-erros(v-show='false')
                el-checkbox(
                    v-model='CheckListagemContratoErro',
                    @change='contratosErros'
                )
                    | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.subTituloMostrarContratosAlerta') }}

        .bloco-novos-contratos-tabela
            TabelaGestaoContratoOriginacaoEmpresaAlvorada(
                :tabelaData='contratosTabela',
                :carregando='carregandoTabela',
                :paginacao='paginacao',
                :totalizador='totalizador',
                @mudarPagina='mudarPagina',
                @ordenarTabela='ordenarTabela',
                @removerContrato='removerContrato',
                @arquivarContrato='arquivarContrato',
                @removerContratoLote='removerContratoLote',
                :removendo='removendoContratos',
                v-if='isAlvorada'
            )
            TabelaGestaoContratoOriginacaoEmpresaPY(
                :tabelaData='contratosTabela',
                :carregando='carregandoTabela',
                :paginacao='paginacao',
                :totalizador='totalizador',
                @mudarPagina='mudarPagina',
                @ordenarTabela='ordenarTabela',
                @removerContrato='removerContrato',
                @arquivarContrato='arquivarContrato',
                @removerContratoLote='removerContratoLote',
                :removendo='removendoContratos',
                v-else-if='this.usuarioLogado.ambienteLogado === "PY"'
            )
            TabelaGestaoContratoOriginacaoEmpresaAR(
                :tabelaData='contratosTabela',
                :carregando='carregandoTabela',
                :paginacao='paginacao',
                :totalizador='totalizador',
                @mudarPagina='mudarPagina',
                @ordenarTabela='ordenarTabela',
                @removerContrato='removerContrato',
                @arquivarContrato='arquivarContrato',
                @arquivarContratos='arquivarContratos',
                :arquivando='arquivandoContratos',
                v-else-if='this.usuarioLogado.ambienteLogado === "AR"'
            )
            TabelaGestaoContratoOriginacaoEmpresa(
                :tabelaData='contratosTabela',
                :carregando='carregandoTabela',
                :paginacao='paginacao',
                :totalizador='totalizador',
                @mudarPagina='mudarPagina',
                @ordenarTabela='ordenarTabela',
                @removerContrato='removerContrato',
                @arquivarContrato='arquivarContrato',
                @cancelarContrato='cancelarContrato',
                @removerContratoLote='removerContratoLote',
                :removendo='removendoContratos',
                v-else
            )

        footer(v-if='this.usuarioLogado.ambienteLogado !== "AR"')
            .remover
                el-button(
                    v-if='removendoContratos',
                    @click.native='removendoContratos = false'
                ) {{ $t('mensagens.comuns.cancelar') }}

                el-button(
                    v-if='!removendoContratos',
                    type='danger',
                    icon='el-icon-delete',
                    @click.native='removendoContratos = true'
                ) {{ $t('mensagens.comuns.remover') }}

                el-button(
                    v-else,
                    type='danger',
                    icon='el-icon-delete',
                    @click.native='removerContratos'
                ) {{ $t('mensagens.comuns.confirmar') }}

        footer(v-else)
            .remover
                el-button(
                    v-if='arquivandoContratos',
                    @click.native='arquivandoContratos = false'
                ) {{ $t('mensagens.comuns.cancelar') }}

                el-button(
                    v-if='!arquivandoContratos',
                    type='danger',
                    icon='el-icon-delete',
                    @click.native='arquivandoContratos = true'
                ) {{ $t('mensagens.comuns.arquivar') }}

                el-button(
                    v-else,
                    type='danger',
                    icon='el-icon-delete',
                    @click.native='arquivarContratosLote'
                ) {{ $t('mensagens.comuns.confirmar') }}
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import BlocoInformacao from '@/components/contratosOriginacao/EmpresaBlocoInformacao.vue';
import BlocoInformacaoSkeleton from '@/components/contratosOriginacao/EmpresaBlocoInformacaoSkeleton.vue';
import BlocoInformacaoBR from '@/components/contratosOriginacao/BlocoInformacaoBR.vue';
import BlocoInformacaoPaises from '@/components/contratosOriginacao/BlocoInformacaoPaises.vue';
import TabelaGestaoContratoOriginacaoEmpresa from '@/components/contratosOriginacao/EmpresaTabelaGestao.vue';
import TabelaGestaoContratoOriginacaoEmpresaPY from '@/components/contratosOriginacao/EmpresaTabelaGestaoPY.vue';
import TabelaGestaoContratoOriginacaoEmpresaAR from '@/components/contratosOriginacao/EmpresaTabelaGestaoAR.vue';
import TabelaGestaoContratoOriginacaoEmpresaAlvorada from '@/components/contratosOriginacao/EmpresaTabelaGestaoAlvorada.vue';
import BlocoPesquisaFiltros from '@/components/contratosOriginacao/EmpresaBlocoPesquisaFiltros.vue';
import ContratoOriginacaoServiceEmpresa from '@/services/ContratoOriginacaoServiceEmpresa.js';
import ContratoOriginacaoService from '@/services/ContratoOriginacaoService';
import { mapGetters } from 'vuex';
import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';

export default {
    name: 'GestaoContratosOriginacao',
    components: {
        BaseHeader,
        BlocoInformacao,
        BlocoInformacaoSkeleton,
        BlocoInformacaoBR,
        BlocoInformacaoPaises,
        TabelaGestaoContratoOriginacaoEmpresa,
        TabelaGestaoContratoOriginacaoEmpresaPY,
        TabelaGestaoContratoOriginacaoEmpresaAR,
        TabelaGestaoContratoOriginacaoEmpresaAlvorada,
        BlocoPesquisaFiltros
    },
    data() {
        return {
            totalContratosOriginacao: {
                totalNaoVisualizado: null,
                totalVisualizado: null,
                totalEmCadastramento: null,
                totalConcluido: null,
                totalAguardandoPreenchimento: null
            },
            contratosTabela: [],
            paginacao: {},
            totalizador: 0,
            params: {
                page: 0,
                size: 10,
                sort: 'dataAtualizacao',
                por: 'desc'
            },
            filtro: {
                numeroContrato: '',
                dataContrato: '',
                idsMateriais: [],
                dataContratoInicio: '',
                dataContratoFim: '',
                idsCultura: [],
                idsSafra: [],
                codigosStatus: [],
                contratosComAlerta: false,
                idsCanais: [],
                idsSegmentos: [],
                idsRegionais: [],
                idsFornecedores: [],
                idsSubTradings: [],
                eudr: null
            },
            skeletonBlocoInforDados: true,
            CheckListagemContratoErro: false,
            carregandoTabela: false,
            carregandoStatusEmpresa: false,
            statusContrato: [],
            statusEmitidos: [],
            codigosStatus: [],
            filtroTotalizadorEudr: false,
            codigosStatusAtivo: [
                { removeStatus: false },
                { removeStatus: false },
                { removeStatus: false },
                { removeStatus: false },
                { removeStatus: false }
            ],
            contratosSelecionados: [],
            removendoContratos: false,
            arquivandoContratos: false,
            botoesSecundarios: [
                {
                    id: 1,
                    nome: this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.recebimentos'
                    ),
                    icone: 'mdi mdi-upload'
                }
            ],
            showModalConsultarDenuncia: false,
            ambientes: AmbientesEmpresas
        };
    },
    mounted() {
        this.buscarTotalizadores();
        this.buscarContratosEmpresa();
        this.buscarStatus();
    },
    computed: {
        ...mapGetters(['isAlvorada', 'usuarioLogado']),
        isBunge() {
            return this.usuarioLogado.isBunge;
        }
    },
    methods: {
        handlerEudrFilter() {
            if (this.filtroTotalizadorEudr) {
                this.filtroTotalizadorEudr = false;
                this.$refs.aplicarFiltroStatus.handlerTagEudr(false);
            } else {
                this.filtroTotalizadorEudr = true;
                this.$refs.aplicarFiltroStatus.handlerTagEudr(true);
            }
        },
        async buscarTotalizadores() {
            if (this.usuarioLogado.ambienteLogado === 'PY') {
                this.buscarTotalizadoresPY();
            } else {
                this.buscarTotalizadoresBR();
            }
        },
        async buscarTotalizadoresBR() {
            try {
                const { data } =
                    await ContratoOriginacaoServiceEmpresa.totalizadores(
                        this.filtro
                    );
                this.totalContratosOriginacao = { ...data };
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.erroBuscarDadosTotalizadores'
                    )
                );
            }
            this.skeletonBlocoInforDados = false;
        },
        async buscarTotalizadoresPY() {
            try {
                const { data } =
                    await ContratoOriginacaoServiceEmpresa.totalizadoresPY(
                        this.filtro
                    );
                this.totalContratosOriginacao = { ...data };
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.erroBuscarDadosTotalizadores'
                    )
                );
            }
            this.skeletonBlocoInforDados = false;
        },
        async buscarContratosEmpresa() {
            if (this.usuarioLogado.ambienteLogado === 'PY') {
                this.buscarContratosEmpresaPY();
            } else if (this.usuarioLogado.ambienteLogado === 'BR') {
                this.buscarContratosEmpresaBR();
            } else {
                this.buscarContratosEmpresaAR();
            }
        },
        async buscarContratosEmpresaBR() {
            this.carregandoTabela = true;
            try {
                const { data } =
                    await ContratoOriginacaoServiceEmpresa.contratos(
                        this.filtro,
                        this.params
                    );
                this.contratosTabela = data.itens;
                this.paginacao = data.paginacao;
                this.totalizador = data.totalizador;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.erroBuscarDadosContrato'
                    )
                );
            }
            this.carregandoTabela = false;
        },
        async buscarContratosEmpresaPY() {
            this.carregandoTabela = true;
            try {
                const { data } =
                    await ContratoOriginacaoServiceEmpresa.contratosPY(
                        this.filtro,
                        this.params
                    );
                this.contratosTabela = data.itens;
                this.paginacao = data.paginacao;
                this.totalizador = data.totalizador;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.erroBuscarDadosContrato'
                    )
                );
            }
            this.carregandoTabela = false;
        },
        async buscarContratosEmpresaAR() {
            this.carregandoTabela = true;
            try {
                const { data } =
                    await ContratoOriginacaoServiceEmpresa.contratosAR(
                        this.filtro,
                        this.params
                    );
                this.contratosTabela = data.itens;
                this.paginacao = data.paginacao;
                this.totalizador = data.totalizador;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.erroBuscarDadosContrato'
                    )
                );
            }
            this.carregandoTabela = false;
        },
        async arquivarContratosLote() {
            if (this.contratosSelecionados.length === 0) {
                this.$notify.warning(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.alertaSemContratosSelecionadosParaRemocao'
                    )
                );
            } else {
                await this.$messageBox.confirm(
                    this.contratosSelecionados.length === 1
                        ? this.$t(
                              'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.msgBoxTituloArquivarContrato'
                          )
                        : this.$t(
                              'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.msgBoxTituloArquivarContratos'
                          ),
                    this.$t('mensagens.comuns.aviso'),
                    {
                        confirmButtonText: this.$t('mensagens.comuns.sim'),
                        cancelButtonText: this.$t('mensagens.comuns.cancelar'),
                        type: 'warning'
                    }
                );
                try {
                    await ContratoOriginacaoServiceEmpresa.arquivarContrato(
                        this.contratosSelecionados
                    );
                } catch (error) {
                    this.$notify.error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.erroArquivarContrato'
                        )
                    );
                }
                this.buscarContratosEmpresa();
                this.$notify.success(
                    this.contratosSelecionados.length === 1
                        ? this.$t(
                              'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.contratoArquivado'
                          )
                        : this.$t(
                              'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.contratosArquivado'
                          )
                );

                this.contratosSelecionados = [];
                this.buscarContratosNaoEnviados();
            }
        },
        async buscarStatus() {
            try {
                this.carregandoStatusEmpresa = true;
                const { data } = await ContratoOriginacaoService.buscarStatus();

                const codesToExclude = [
                    'AJUSTADO_PELA_REVENDA',
                    'DISCREPANCIA',
                    'PENDENTE_ACEITE'
                ];
                const statusFiltrado =
                    this.usuarioLogado.ambienteLogado !== 'AR'
                        ? data.filter(
                              item => !codesToExclude.includes(item.codigo)
                          )
                        : data;

                this.statusContrato = statusFiltrado;
                this.carregandoStatusEmpresa = false;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarStatus'
                    )
                );
            }
        },
        mudarPagina(novaPagina) {
            this.paginacao.pagina = novaPagina;
            this.params.page = novaPagina;
            this.buscarContratosEmpresa();
        },
        ordenarTabela(column) {
            if (column.prop === 'subEmpresaNome') {
                this.params.sort = 'empresaNome';
            } else {
                this.params.sort = column.prop;
            }

            if (column.order === 'ascending') {
                this.params.por = 'asc';
            } else if (column.order === 'descending') {
                this.params.por = 'desc';
            }
            this.buscarContratosEmpresa();
        },
        adicionarFiltros(filtro) {
            this.filtro.dataContrato = filtro.dataCadastro;
            this.filtro.idsMateriais = filtro.culturas;
            this.filtro.dataContratoInicio = filtro.dataCadastroInicio;
            this.filtro.dataContratoFim = filtro.dataCadastroFim;
            this.filtro.idsSafra = filtro.safras;
            this.filtro.codigosStatus = filtro.status;
            this.filtro.numeroContrato = filtro.pesquisa;
            this.filtro.idsCanais = filtro.canais;
            this.filtro.idsRegionais = filtro.regionais;
            this.filtro.idsSegmentos = filtro.segmentos;
            this.filtro.idsFornecedores = filtro.fornecedores;
            this.filtro.idsSubTradings = filtro.subTradings || [];
            this.filtro.eudr = filtro.eudr;
            this.filtroTotalizadorEudr = !!filtro.eudr;
            this.params.page = 0;
            this.sincronizarBlocosStatus(filtro.status);
            this.buscarContratosEmpresa();
            this.buscarTotalizadores();
        },
        contratosErros() {
            if (this.CheckListagemContratoErro) {
                this.filtro.contratosComAlerta = true;
            } else {
                this.filtro.contratosComAlerta = false;
            }
            this.buscarContratosEmpresa();
        },
        novoContrato() {
            this.$router.push({ name: 'CadastrarContratoOriginacaoEmpresa' });
        },
        uploadPlanilha() {
            this.$router.push({ name: 'UploadVerificacaoTerritorios' });
        },
        async removerContrato(idContratoOriginacao) {
            try {
                const idsContratosOriginacao = [idContratoOriginacao];
                await ContratoOriginacaoServiceEmpresa.removerContratoLote(
                    idsContratosOriginacao
                );
                this.buscarContratosEmpresa();
                this.$notify.success(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.contratoRemovido'
                    )
                );
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.erroRemoverContrato'
                    )
                );
            }
        },
        async arquivarContrato(idContratoOriginacao) {
            try {
                const idsContratosOriginacao = [idContratoOriginacao];
                await ContratoOriginacaoServiceEmpresa.arquivarContrato(
                    idsContratosOriginacao
                );
                this.$notify.success(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.contratoArquivado'
                    )
                );
                this.buscarTotalizadores();
                this.buscarContratosEmpresa();
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.erroArquivarContrato'
                    )
                );
            }
        },
        async cancelarContrato(idContratoOriginacao) {
            try {
                const idsContratosOriginacao = [idContratoOriginacao];
                await ContratoOriginacaoServiceEmpresa.cancelarContrato(
                    idsContratosOriginacao
                );
                this.$notify.success(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.contratoCancelado'
                    )
                );
                this.buscarTotalizadores();
                this.buscarContratosEmpresa();
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.erroCancelarContrato'
                    )
                );
            }
        },
        statusEmpresa(status) {
            this.statusEmitidos = status;
        },
        aplicarFiltroStatus(status, indice) {
            const removeStatus = this.codigosStatusAtivo[indice].removeStatus;

            this.codigosStatusAtivo[indice].removeStatus = !removeStatus;

            if (this.codigosStatusAtivo[indice].removeStatus) {
                this.$refs.aplicarFiltroStatus.inserirFiltrosStatus(status);
            } else {
                this.$refs.aplicarFiltroStatus.removerFiltroStatus(status);
            }
        },

        sincronizarBlocosStatus(statusFiltros) {
            this.codigosStatusAtivo.forEach(codigoStatus => {
                codigoStatus.removeStatus = false;
            });

            if (statusFiltros && statusFiltros.length > 0) {
                this.statusEmitidos.forEach((status, index) => {
                    if (this.codigosStatusAtivo && this.codigosStatusAtivo[index]) {
                        const statusAtivo = statusFiltros.includes(status.codigo);
                        this.codigosStatusAtivo[index].removeStatus = statusAtivo;
                    }
                });
            }
        },
        async removerContratoLote(idsContratosOriginacao) {
            this.contratosSelecionados = idsContratosOriginacao;
        },
        async arquivarContratos(idsContratosOriginacao) {
            this.contratosSelecionados = idsContratosOriginacao;
        },
        async removerContratos() {
            if (this.contratosSelecionados.length === 0) {
                this.$notify.warning(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.alertaSemContratosSelecionadosParaRemocao'
                    )
                );
            } else {
                await this.$messageBox.confirm(
                    this.contratosSelecionados.length === 1
                        ? this.$t(
                              'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.msgBoxTituloRemocaoContrato'
                          )
                        : this.$t(
                              'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.msgBoxTituloRemocaoContratos'
                          ),
                    this.$t('mensagens.comuns.aviso'),
                    {
                        confirmButtonText: this.$t('mensagens.comuns.sim'),
                        cancelButtonText: this.$t('mensagens.comuns.cancelar'),
                        type: 'warning'
                    }
                );
                try {
                    if (this.usuarioLogado.ambienteLogado === 'AR') {
                        await ContratoOriginacaoServiceEmpresa.removerContratoLoteArgentina(
                            this.contratosSelecionados
                        );
                    } else {
                        await ContratoOriginacaoServiceEmpresa.removerContratoLote(
                            this.contratosSelecionados
                        );
                    }
                } catch (error) {
                    this.$notify.error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.erroRemoverContrato'
                        )
                    );
                }
                this.buscarContratosEmpresa();
                this.$notify.success(
                    this.contratosSelecionados.length === 1
                        ? this.$t(
                              'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.contratoRemovido'
                          )
                        : this.$t(
                              'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.contratosRemovido'
                          )
                );

                this.contratosSelecionados = [];
                this.buscarContratosNaoEnviados();
            }
        },
        async exportarRelatorioXlsx() {
            if (this.usuarioLogado.ambienteLogado === 'PY') {
                this.exportarRelatorioXlsxPY();
            } else if (this.usuarioLogado.ambienteLogado === 'AR') {
                this.exportarRelatorioXlsxAR();
            } else {
                this.exportarRelatorioXlsxBR();
            }
        },
        async exportarRelatorioXlsxBR() {
            this.carregandoTabela = true;
            try {
                await ContratoOriginacaoServiceEmpresa.exportarRelatorioXlsx(
                    this.filtro
                );
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.erroExportarRelatorio'
                    )
                );
            }
            this.carregandoTabela = false;
        },
        async exportarRelatorioXlsxPY() {
            this.carregandoTabela = true;
            try {
                await ContratoOriginacaoServiceEmpresa.exportarRelatorioPYXlsx(
                    this.filtro
                );
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.erroExportarRelatorio'
                    )
                );
            }
            this.carregandoTabela = false;
        },
        async exportarRelatorioXlsxAR() {
            this.carregandoTabela = true;
            try {
                await ContratoOriginacaoServiceEmpresa.exportarRelatorioARXlsx();
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.erroExportarRelatorio'
                    )
                );
            }
            this.carregandoTabela = false;
        },
    async exportarInformesPY() {
        this.carregandoTabela = true;

        try {
            const ids = this.contratosTabela.map(c => c.id);

            await ContratoOriginacaoServiceEmpresa.exportarInformesPY(
                ids
            );
        } catch (error) {
            this.$notify.error(
                this.$t(
                    'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.erroExportarRelatorio'
                )
            );
        }

        this.carregandoTabela = false;
    }
    }
};
</script>

<style lang="scss">
#gestao-contratos-originacao {
    footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .remover {
        margin-top: 16px;
    }

    .bloco-infor-dados {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 8px;
        width: 100%;
        flex-wrap: wrap;

        #empresa-bloco-informacao {
            cursor: pointer;
        }

        .sem-filtro {
            cursor: default !important;
        }
    }

    .bloco-novos-contratos-preenchimento,
    .bloco-infor-dados,
    .bloco-pesquisa-filtros,
    .bloco-novos-contratos-tabela {
        margin-top: 20px;
    }

    .total-contratos {
        font-size: 19px;
        margin-right: 6px;
    }

    .secao-listagem-filtro {
        display: flex;
        margin-top: 20px;
        gap: 25px;
        justify-content: space-between;

        .el-checkbox__label,
        .titulo-listagem h3 {
            font-weight: bold;
        }

        .titulo-listagem {
            width: 50%;
        }
    }

    #empresa-bloco-informacao {
        border: 1px solid #e1e1e1;

        &.bloco-infor-dados-ativo {
            border-color: var(--primary) !important;
        }
    }

    .base-button-exportar-relatorio {
        display: flex;
        align-items: center;
    }

    .base-button-container__btn {
        span {
            margin-left: 5px;
        }
    }
}

.icon-rotate {
    transform: rotate(180deg);
    display: block;
}
</style>
